module.exports = __webpack_public_path__ + "img/yellow-gross-icon.02d62040.svg";